import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';

export default function SnippetHeading({ data, children }) {
  return <HeaderContainerForm
    title='Snippet'
    data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
    onCancel={() => history.goBack()}
  >
    {children}
  </HeaderContainerForm>
}
